export default __webpack_public_path__ + "static/media/WHTicon.61c113ca.svg";